import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { status } from "config/Consts";
import { useApplyJobQuery, useSaveJobsQuery } from "queries/Jobs";
import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import { updateJobAppliedStatus, updateJobSavedStatus } from "utils/jobs";
interface IJobAppliedModal {
  openModal: boolean;
  setOpenModal: (arg?: any) => void;
  id: string;
  jobName: string;
  company: string;
  handleApplied?: (arg?: any) => void;
  isNotInterested?: boolean;
  setInterested?: (arg?: any) => void;
  setAllJobs?: (arg?: any) => void;
  index?: number;
}

const jobStatus = ["Save for later", "Not interested", "Applied"];

interface IHyperLink {
  children: ReactNode;
  url: string;
  target: string;

  tabIndex?: number;
}
const HyperLink: FC<IHyperLink> = ({ children, url, target, tabIndex = 0 }) => {
  return (
    <span
      role="link"
      className="hover:underline cursor-pointer"
      onClick={() => {
        window.open(url, target);
      }}
      tabIndex={tabIndex}
      onKeyDown={(e: any) => {
        e.code === "Enter" && window.open(url, target);
      }}
    >
      {children}
    </span>
  );
};

const JobAppliedModal: FC<IJobAppliedModal> = ({
  openModal,
  setOpenModal,
  id,
  jobName,
  company,
  handleApplied,
  isNotInterested,
  setInterested,
  setAllJobs,
  index,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(jobStatus[1]);
  const payload: any = useMemo(
    () => ({
      jobId: id,
      status: selectedStatus,
    }),
    [id, selectedStatus]
  );

  const callback =
    selectedStatus === jobStatus[0]
      ? () => updateJobSavedStatus({ isSaved: false, setAllJobs, index })
      : () =>
          updateJobAppliedStatus({
            isApplied: false,
            isNotInterested: selectedStatus === jobStatus[1],
            setAllJobs,
            index: index ?? -1,
          });

  const { mutate: applyJob, isLoading } = useApplyJobQuery(
    selectedStatus,
    callback
  );
  const { mutate: saveJobQuery, isLoading: savingJob } = useSaveJobsQuery({
    message: "You can view this job in the saved job section",
  });

  const handleClick = (recStatus: string | undefined = undefined): void => {
    if ((recStatus?.length ?? -1 > 0) as boolean) payload.status = recStatus;
    if (payload.status === jobStatus[1]) {
      payload.notInterested = true;
      setInterested?.(false);
    }
    if (payload.status === jobStatus[0]) {
      saveJobQuery({
        jobId: id,
      });
      updateJobSavedStatus({ isSaved: true, setAllJobs, index });
      setOpenModal(false);
    } else {
      applyJob(payload);
      updateJobAppliedStatus({
        isApplied: true,
        isNotInterested: payload.status === jobStatus[1],
        setAllJobs,
        index: index ?? -1,
      });
      setOpenModal(false);
    }
    // setOpenModal(false);
  };

  useEffect(() => {
    if (isNotInterested as boolean) setSelectedStatus(status[1]);
  }, [isNotInterested]);

  return (
    <>
      <Modal
        isOpen={openModal}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        onClose={() => {
          handleClick(status[0]);
          // setOpenModal(false);
        }}
        isCentered={true}
        size={{
          base: "sm",
          md: "md",
          xl: "lg",
        }}
      >
        <ModalOverlay />
        <ModalContent maxH="90vh" overflow="auto">
          <ModalHeader px={{ base: 6, md: 10 }}>
            <Text className="heading-md">How did it go?</Text>
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody px={{ base: 6, md: 10 }}>
            <Text
              fontSize={{
                base: 14,
                md: 20,
              }}
              mb={8}
              mt={{ base: 0, md: 4 }}
            >
              Keep track of <span className="font-bold">{jobName}</span> at{" "}
              <span className="italic">{company}</span>&nbsp; by adding it to
              your{" "}
              <HyperLink url="/jobs/saved" target="_blank">
                Saved Jobs
              </HyperLink>{" "}
              or marking it as Applied to add it to the{" "}
              <HyperLink url="/jobs/applied" target="_blank">
                Applied Jobs
              </HyperLink>{" "}
              page.
            </Text>

            <RadioGroup value={selectedStatus} onChange={setSelectedStatus}>
              <Stack>
                {jobStatus.map((st, idx) => (
                  <Radio value={st} key={idx} size="lg">
                    {st}
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
          </ModalBody>
          <ModalFooter className="flex flex-col gap-8 mt-8">
            <Button
              // colorScheme="primaryGreen"
              background="teal.600 !important"
              color="white"
              // mr={3}
              onClick={() => handleClick()}
              isLoading={isLoading || savingJob}
              fontSize={{
                base: 14,
                md: 20,
              }}
            >
              Save and Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default JobAppliedModal;
